export default new class Menu {
    constructor() {
        this.pageBody = 'page__body';
        this.menuOpen = 'menu_is-open';
        this.burger = 'burger';
        this.burgerOpen = 'burger_is-open';
        this.menuItemParent = 'menu__item_is-parent';
        this.menuItemOpen = 'menu__item_open';
        this.scrollLink = 'scroll_to';

        this.openMenu();
        this.openParentMenu();
        this.scrollTo();

    }
    openParentMenu () {
        $(document).on('click', `.${this.menuItemParent}`, ({ target }) => {
            const isParent = $(target).parent().hasClass(`${this.menuItemParent}`);

            if (isParent) {
                $(`.${this.menuItemParent}`).toggleClass(`${this.menuItemOpen}`);
            }
        });

        $(document).on('click', ({ target }) => {
            if ($(target).closest(`.${this.menuItemOpen}`).length === 0) {
                $(`.${this.menuItemParent}`).removeClass(`${this.menuItemOpen}`);
            }
        });
    }
    openMenu() {
        $(document).on('click', `.${this.burger}`, ({currentTarget}) => {
            const burger =  $(currentTarget)
            const page = $(`.${this.pageBody}`);
            const isActive =  page.hasClass(`${this.menuOpen}`);

            if(!isActive) {
                burger.addClass(`${this.burgerOpen}`);
                page.addClass(`${this.menuOpen}`);
            } else {
                burger.removeClass(`${this.burgerOpen}`);
                page.removeClass(`${this.menuOpen}`);
            }
        });
    }
    scrollTo() {
        const arScrollLink = document.querySelectorAll(`.${this.scrollLink}`);
        arScrollLink.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const href = e.currentTarget.getAttribute('href');
                const burger = $(`.${this.burger}`);
                const page = $(`.${this.pageBody}`);
                const isActive =  page.hasClass(`${this.menuOpen}`);

                if(isActive) {
                    burger.removeClass(`${this.burgerOpen}`);
                    page.removeClass(`${this.menuOpen}`);
                }

                const thisUrl =  window.location.href.split('#')[0]

                if (thisUrl.slice(0, -3) === window.location.origin) {
                    $('html, body').animate({
                        scrollTop: $(href).offset().top
                    }, 1000);

                } else {
                    window.location.href = window.location.origin + href;
                }

            });
        });
    }
}();
